import React from 'react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
const stats = [{
  value: '+300',
  label: 'Practical decisions & solutions'
}, {
  value: '6',
  label: 'Master volumes'
}, {
  value: '5',
  label: 'Exclusive bonuses'
}];
export function Promise() {
  return <Section dark data-id="element-261" data-mp="1q39mymcw87h0">
      <Eyebrow data-id="element-262" data-mp="1q4uee33wvaan">More than a welding guide…</Eyebrow>
      <Heading data-id="element-263" data-mp="12dp2fz13d25m">
        It’s your visual decision system for every time a weld doesn’t turn out the way you expected
      </Heading>

      <ul className="mt-8 grid gap-3 sm:grid-cols-3" data-id="element-264" data-mp="xfwy25j9fnkj">
        {stats.map(s => <li key={s.label} className="flex items-center gap-4 rounded-xl border border-ink-500 bg-ink-700 px-4 py-4 sm:flex-col sm:gap-1 sm:py-6 sm:text-center" data-id="element-265" data-mp="1c406rmootdd1">
            <span className="font-display text-4xl font-extrabold leading-none text-flame-500 sm:text-5xl" data-id="element-266" data-mp="jmntqja65s8v">
              {s.value}
            </span>
            <span className="text-[13px] font-semibold uppercase leading-tight tracking-wide text-zinc-300 sm:text-sm" data-id="element-267" data-mp="em9wzxe0q4q5">
              {s.label}
            </span>
          </li>)}
      </ul>

      <div className="mt-9" data-id="element-268" data-mp="18w0532nosrbp">
        <CTAButton data-id="element-269" data-mp="1dp30zhfxscv2" />
      </div>
    </Section>;
}